export default __webpack_public_path__ + "media/icons/first-to-review-7fd6b82a.svg";